
import {Vue} from "vue-class-component";

export default class SongsCounter extends Vue {}
